/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import copyIcon from "../../Assets/img/copy.svg";
import { useDispatch, useSelector } from "react-redux";
import { onGetOfferBenefits } from "../../Store/Slices/offerNdBenefitsSlice";
// import Loader from "../../Utility/Loader/Loader";
import {
  GetSegment,
  SectionMasterData,
  UtilityReducer,
  ValidateLoginToken,
} from "../../Utility/Utility";
import NoRecord from "../NoRecord/NoRecord";
import { toast, ToastContainer } from "react-toastify";
import { decryptAES } from "../../Common/Axios/encrypt";
import getTranslation from "../../TranslationUtility/TranslationUtility";

const OffersNdBenefits = ({ login }) => {
  const dispatch = useDispatch();
  const translation = getTranslation();
  const { sectionMasterData } = SectionMasterData(login);

  const [activeFilter, setActiveFilter] = useState(translation?.allLabel);
  const [expandedCard, setExpandedCard] = useState(null);
  const offerIsLoading = useSelector(
    (state) => state?.offerBenefitsReducer?.isgetLoading
  );
  const token = ValidateLoginToken();

  const offerNdBenfitData = useSelector(
    (state) => state?.offerBenefitsReducer?.offerBenefitData?.items
  );

  const reversedOfferNdBenfitData = Array.isArray(offerNdBenfitData)
    ? [...offerNdBenfitData].reverse()
    : [];
  const hasOffers = reversedOfferNdBenfitData.some(
    (offer) => offer?.categoryName !== "Brand"
  );
  const hasGiftCards = reversedOfferNdBenfitData.some((offer) =>
    offer?.categoryName === "Brand"
  );

  const FilterOptions =
    hasOffers && hasGiftCards
      ? [translation?.allLabel, translation?.offers, translation?.giftCards]
      : hasOffers
        ? [translation?.allLabel, translation?.offers]
        : hasGiftCards
          ? [translation?.allLabel, translation?.giftCards]
          : [translation?.allLabel, translation?.offers, translation?.giftCards];

  const handleToggle = (index) => {
    setExpandedCard((prev) => (prev === index ? null : index));
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options);
  };

  useEffect(() => {
    dispatch(onGetOfferBenefits({ memberIdentifier: token?.memberIdentifier }));
  }, []);

  // Filter data based on the selected filter
  const filteredData = reversedOfferNdBenfitData?.filter((offer) => {
    if (activeFilter === translation?.allLabel) return true;
    if (activeFilter === translation?.offers) return offer?.categoryName !== "Brand";
    if (activeFilter === translation?.giftCards) return offer?.categoryName === "Brand";
    return true;
  });

  //to handle copy
  const handleCopy = (offer, type) => {
    let couponCode = "";
    if (type === "couponcode") {
      if (decryptAES(offer?.gCid)) {
        couponCode = decryptAES(offer?.couponCode);
      } else {
        couponCode = decryptAES(offer?.couponCode);
      }
    } else if (type === "gcid") {
      couponCode = decryptAES(offer?.gCid);
    } else if (type === "couponpin" && offer?.categoryName === "Brand") {
      couponCode = decryptAES(offer?.couponPin);
    } else if (type === "referenceNumber") {
      couponCode = offer;
    } else if (type === "couponpin" && offer?.categoryName !== "Brand") {
      couponCode = decryptAES(decryptAES(offer?.couponPin));
    }
    navigator.clipboard.writeText(couponCode);

    toast.success(translation?.copiedSuccessfully, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
      style: {
        margin: "30px",
        fontSize: "12px",
        padding: "8px",
        minHeight: "40px",
      },
    });
  };
  const headline = (offer) => {
    const htmlContent = offer?.sectionName;

    if (htmlContent) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, "text/html");
      return doc.body.textContent?.length > 35
        ? doc.body.textContent?.substring(0, 35) + "..."
        : doc.body.textContent;
    }
  };
  const segmentData = GetSegment();
  const card = UtilityReducer();
  const segments = segmentData?.data?.[0]?.mappedSegment;
  const handleCard = (offerData) => {
    const htmlContent = sectionMasterData?.find(
      (findData) => findData?.id === offerData?.sectionId
    )?.segmentId;
    const currentSegmentCard = segments?.find(
      (filterData) => filterData?.segmentId === htmlContent
    )?.subIdentifier;
    const currentCardData = card?.creditCards?.find(
      (filterData) => filterData?.identifier === currentSegmentCard
    );
    return currentCardData;
  };

  useEffect(() => {
    window.scrollTo(0, 0, { behavior: "smooth" });
  }, []);

  const createHotelMembershipMsg = (translation) => {
    const statusMessageMap = {
      [translation.claim_initiated]: "pendingMessage",
      [translation.benefit_allotted]: "successMessage",
      [translation.failed]: "failMessage",
    };
    return (offer) => {
      if (offer?.membershipType !== translation?.membership_hotel) {
        return translation?.giftCardUsageInstructions;
      }
      const messageKey = statusMessageMap[offer?.orderStatus];
      return (messageKey && offer?.[messageKey]) ? <div className="hotel-membership-msg">{offer?.[messageKey]}</div> : <></>;
    };
  };
  const hotelMembershipMsg = createHotelMembershipMsg(translation);
  return (
    <>
      <ToastContainer />
      {offerIsLoading ? (
        <></>
      ) : (
        <div className="bg-white h-full">
          {filteredData?.length ? (
            <div className="m-2">
              <div className="max-w-sm mx-auto bg-white top-[64px] z-10 mb-4">
                <div className="flex gap-2 flex-wrap mt-4">
                  {FilterOptions.map((filter, index) => (
                    <button
                      key={index}
                      onClick={() => setActiveFilter(filter)}
                      className={`px-4 py-2 feat-card ${activeFilter === filter
                        ? "feat-card-active"
                        : "feat-card-non-active"
                        }`}
                    >
                      {filter}
                    </button>
                  ))}
                </div>
              </div>
              {filteredData?.map((offer, index) => (
                <div
                  key={index}
                  className="max-w-sm mx-auto bg-white offer-card shadow-md border relative mt-8"
                >
                  <span className="absolute left-4 offer-box">
                    {headline(offer)
                      ? headline(offer)
                      : translation?.welcomeBenefits}
                  </span>

                  <div className="p-4">
                    <div className="flex items-center mt-4">
                      <div className="w-10">
                        <img
                          src={
                            offer?.categoryName === "Brand"
                              ? offer?.offerImage
                              : `${process.env.REACT_APP_CLIENT_IMAGE_URL}${offer?.offerImage}`
                          }
                          alt="Offer Image"
                          className="img-size"
                        />
                      </div>
                      <div className="flex flex-grow items-center">
                        <div className="offer-txt">{offer?.merchant}</div>
                        {offer?.membershipType === translation?.membership_hotel && offer?.orderStatus &&
                          <div className={`flex status-tag ${offer?.orderStatus === translation?.claim_initiated ? "status-tag-claim-initiated " : ""}${offer?.orderStatus === translation?.benefit_allotted ? "status-tag-benefit-allotted " : ""}${offer?.orderStatus === translation?.failed ? "status-tag-failed" : ""}`}>{offer?.orderStatus}</div>}
                      </div>
                    </div>
                  </div>

                  <div className="img-txt"></div>
                  < div className="p-4">
                    {offer?.membershipType !== translation?.membership_hotel ?
                      <div className="date-title">
                        {translation?.validity}:{" "}
                        <span className="font-semibold">{`${formatDate(
                          offer?.validfrom
                        )} to ${formatDate(offer?.validto)}`}</span>
                      </div> : <></>}
                    {offer?.membershipType !== translation?.membership_hotel ? <>
                      {offer?.categoryName === "Brand" ? (
                        <div className="coupon-card-1">
                          <div className="coupon-row-1">
                            <div>
                              <span className="code-label">
                                {translation?.couponCode}
                              </span>
                              <div className="flex items-center gap-2">
                                <span className="text-sm font-semibold pr-2">
                                  {decryptAES(offer?.couponCode)}
                                </span>
                                <img
                                  src={copyIcon}
                                  alt="Copy Icon"
                                  className="h-4 w-4"
                                  onClick={() => handleCopy(offer, "couponcode")}
                                />
                              </div>
                            </div>
                          </div>
                          {offer?.cta ? (
                            <div className="flex items-center">
                              <hr className="flex-grow border-t border-gray-300" />
                              <button
                                className="ml-4 offer-redeem px-4 py-1"
                                onClick={() => window.open(offer?.cta, "_blank")}
                              >
                                {translation?.redeem}
                              </button>
                            </div>
                          ) : (
                            ""
                          )}{" "}
                          <div className="coupon-row-1">
                            <div>
                              <span className="code-label">
                                {decryptAES(offer?.couponPin)
                                  ? (translation?.pinText || "Pin")
                                  : (translation?.gcidText || "GCID")}
                              </span>
                              <div className="flex items-center gap-2">
                                <span className="text-sm font-semibold pr-2">
                                  {decryptAES(offer?.couponPin)
                                    ? decryptAES(offer?.couponPin)
                                    : decryptAES(offer?.gCid)}
                                </span>
                                <img
                                  src={copyIcon}
                                  alt="Copy Icon"
                                  className="h-4 w-4"
                                  onClick={() =>
                                    handleCopy(
                                      offer,
                                      decryptAES(offer?.couponPin)
                                        ? "couponpin"
                                        : "gcid"
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                          <>
                            <p className="benefit-des mt-4">{offer?.offerTitle}</p>

                            {(decryptAES(offer?.gCid) || decryptAES(offer?.couponPin)) ?
                              <div className="coupon-card-1">
                                <div className="coupon-row-1">
                                  <div>
                                    <span className="code-label">
                                      {translation?.couponCode}
                                    </span>
                                    <div className="flex items-center gap-2">
                                      <span className="text-sm font-semibold pr-2">
                                        {decryptAES(offer?.couponCode)}
                                      </span>
                                      <img
                                        src={copyIcon}
                                        alt="Copy Icon"
                                        className="h-4 w-4"
                                        onClick={() => handleCopy(offer, "couponcode")}
                                      />
                                    </div>
                                  </div>
                                </div>
                                {offer?.cta ? (
                                  <div className="flex items-center">
                                    <hr className="flex-grow border-t border-gray-300" />
                                    <button
                                      className="ml-4 offer-redeem px-4 py-1"
                                      onClick={() => window.open(offer?.cta, "_blank")}
                                    >
                                      {translation?.redeem}
                                    </button>
                                  </div>
                                ) : (
                                  <div className="membership-card-seprater" />
                                )}
                                <div className="coupon-row-1">
                                  <div>
                                    <span className="code-label">
                                      {decryptAES(offer?.couponPin)
                                        ? (translation?.pinText || "Pin")
                                        : (translation?.gcidText || "GCID")}
                                    </span>
                                    <div className="flex items-center gap-2">
                                      <span className="text-sm font-semibold pr-2">
                                        {decryptAES(offer?.couponPin)
                                          ? decryptAES(decryptAES(offer?.couponPin))
                                          : decryptAES(offer?.gCid)}
                                      </span>
                                      <img
                                        src={copyIcon}
                                        alt="Copy Icon"
                                        className="h-4 w-4"
                                        onClick={() =>
                                          handleCopy(
                                            offer,
                                            decryptAES(offer?.couponPin)
                                              ? "couponpin"
                                              : "gcid"
                                          )
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div> : <div className="p-3 code-box mt-4 flex items-center justify-between">
                              <div className="flex items-center gap-2">
                                <span className="text-sm font-semibold">
                                  {decryptAES(offer?.couponCode)}
                                </span>
                                <img
                                  src={copyIcon}
                                  alt="Copy Icon"
                                  className="h-4 w-4"
                                  onClick={() => handleCopy(offer, "couponcode")}
                                />
                              </div>
                              {offer?.cta ? (
                                <button
                                  className="offer-redeem px-4 py-1"
                                  onClick={() => window.open(offer?.cta, "_blank")}
                                >
                                  {translation?.redeem}
                                </button>
                              ) : (
                                ""
                              )}
                            </div>
                            }
                          </>
                      )}
                      {offer?.categoryName === "Brand" && (
                        <div className="w-full max-w-sm border rounded-md shadow-sm mt-3">
                          <div className="flex items-center justify-between border-b px-4 py-2">
                            <div className="view-data-th">
                              {translation?.denomination}
                            </div>
                            <div className="border-l h-4 border-gray-300 mx-2"></div>
                            <div className="view-data-th">
                              {translation?.quantity}
                            </div>
                          </div>

                          <div className="flex items-center justify-between px-4 py-3">
                            <div className="view-data-coln">
                              ₹ {offer?.denomination}
                            </div>
                            <div className="view-data-coln">{offer?.quantity}</div>
                          </div>
                        </div>
                      )}
                    </> : <></>}


                    {offer?.membershipType === translation?.membership_hotel ? <>
                      <div className="membership-coupon-card">
                        <div className="">
                          <div className="">
                            <div className="hotel-membership-code-label">
                              {translation?.benifitName}
                            </div>
                            <div className="flex-1 min-w-0 truncate hotel-membership-value-text">
                              {offer?.offerTitle}
                            </div>
                          </div>
                        </div>
                        <div className="membership-card-seprater"></div>
                        <div className="">
                          <div>
                            <div className="hotel-membership-code-label">
                              {translation?.ClaimReferenceNo}
                            </div>
                            <div className="flex flex-grow justify-between items-center gap-2">
                              <span className="flex-1 min-w-0 truncate hotel-membership-value-text">
                                {offer?.referenceNumber}
                              </span>
                              <img
                                src={copyIcon}
                                alt="Copy Icon"
                                className="h-4 w-4"
                                onClick={() => handleCopy(offer?.referenceNumber, "referenceNumber")}
                              />
                            </div>
                          </div>
                        </div>
                        {offer?.statusRemarkDetails && <>
                          {Object.entries(offer?.statusRemarkDetails).map(([key, value]) => {
                            return <>
                              <div className="membership-card-seprater"></div>
                              <div className="">
                                <div>
                                  <div className="hotel-membership-code-label">
                                    {key}
                                  </div>
                                  <div className="flex flex-grow justify-between items-center">
                                    <div className="hotel-membership-value-text">
                                      {value}
                                    </div>
                                    <img
                                      src={copyIcon}
                                      alt="Copy Icon"
                                      className="h-4 w-4"
                                      onClick={() => handleCopy(value, "referenceNumber")}
                                    />
                                  </div>
                                </div>
                              </div>
                            </>
                          })

                          }
                        </>}
                      </div>
                    </>
                      : <></>}
                    <div className="view-des">
                      <p className="mt-1">
                        {hotelMembershipMsg(offer)}
                      </p>
                    </div>
                    {handleCard(offer) ? (
                      <div className="mt-4 items-center">
                        {expandedCard === index && (
                          <>
                            {handleCard(offer) && (
                              <div className="dot-border">
                                {!decryptAES(offer?.gCid) && (
                                  <div className="dashed-border" />
                                )}
                                <div className="card-head mt-3">
                                  <span className="mb-2">
                                    {translation?.cardUsed}:{" "}
                                  </span>
                                </div>
                                <div className="flex items-center mt-2 mb-4">
                                  <img
                                    src={handleCard(offer)?.backgroundcolor}
                                    alt="Card"
                                    className="cr-card-img mr-3"
                                  />
                                  <div>
                                    <p className="card-txt">
                                      {handleCard(offer)?.CardTypeName}
                                    </p>
                                    <p className="card-num pt-2">
                                      •••• {handleCard(offer)?.CardNoLast4Digit}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                        <button
                          onClick={() => handleToggle(index)}
                          className="text-gray-700 font-semibold flex items-center gap-1"
                        >
                          {expandedCard === index ? (
                            <>
                              <span>{translation?.viewLess}</span>
                              <i className="fa fa-angle-up ml-2"></i>
                            </>
                          ) : (
                            <>
                              <span>{translation?.viewMore}</span>
                              <i className="fa fa-angle-down ml-2"></i>
                            </>
                          )}
                        </button>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

              ))}
            </div>
          ) : (
            <NoRecord />
          )}
        </div >
      )}
    </>
  );
};

export default OffersNdBenefits;
